/* eslint-disable */
import React from 'react';
import { Box } from '@mui/material';

// A simple markdown renderer
// This is a very basic implementation that handles common markdown elements
// For a production app, consider using a library like 'react-markdown'
const MarkdownRenderer = ({ markdown, className }) => {
  if (!markdown) return null;

  // Process the markdown to convert it to HTML
  const processMarkdown = (markdown) => {
    let html = markdown;

    // Convert headers
    html = html.replace(/^# (.*$)/gm, '<h1>$1</h1>');
    html = html.replace(/^## (.*$)/gm, '<h2>$1</h2>');
    html = html.replace(/^### (.*$)/gm, '<h3>$1</h3>');
    html = html.replace(/^#### (.*$)/gm, '<h4>$1</h4>');
    html = html.replace(/^##### (.*$)/gm, '<h5>$1</h5>');
    html = html.replace(/^###### (.*$)/gm, '<h6>$1</h6>');

    // Convert bold and italic
    html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    html = html.replace(/__(.*?)__/g, '<strong>$1</strong>');
    html = html.replace(/_(.*?)_/g, '<em>$1</em>');

    // Convert links
    html = html.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');

    // Convert bullet points
    html = html.replace(/^\* (.*$)/gm, '<li>$1</li>');
    html = html.replace(/^- (.*$)/gm, '<li>$1</li>');
    html = html.replace(/^  \* (.*$)/gm, '<li class="sub-list">$1</li>');
    html = html.replace(/^  - (.*$)/gm, '<li class="sub-list">$1</li>');

    // Wrap lists in <ul> tags
    // Find sequences of <li> tags
    const liRegex = /(<li>.*<\/li>\n)+/g;
    html = html.replace(liRegex, (match) => {
      return `<ul>\n${match}</ul>\n`;
    });

    // Convert paragraphs - note this should be done last to avoid conflicts
    // Split by new lines and wrap non-element text in <p> tags
    const lines = html.split('\n');
    html = lines
      .map((line) => {
        // Skip if line is empty or already has HTML tags
        if (line.trim() === '' || /<[a-z][\s\S]*>/i.test(line)) {
          return line;
        }
        return `<p>${line}</p>`;
      })
      .join('\n');

    return html;
  };

  return (
    <Box
      className={className}
      sx={{
        '& h1': {
          fontSize: '2em',
          marginBottom: '0.5em',
          fontWeight: 'bold',
          borderBottom: '1px solid #ddd',
          paddingBottom: '0.2em',
        },
        '& h2': {
          fontSize: '1.5em',
          marginTop: '1em',
          marginBottom: '0.5em',
          fontWeight: 'bold',
        },
        '& h3': {
          fontSize: '1.25em',
          marginTop: '1em',
          marginBottom: '0.5em',
          fontWeight: 'bold',
        },
        '& p': { marginBottom: '1em', lineHeight: 1.6 },
        '& ul': { marginBottom: '1em', paddingLeft: '2em' },
        '& li': { marginBottom: '0.2em' },
        '& li.sub-list': { marginLeft: '1em' },
        '& a': {
          color: '#5469d4',
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        },
        '& strong': { fontWeight: 'bold' },
        '& em': { fontStyle: 'italic' },
      }}
      dangerouslySetInnerHTML={{ __html: processMarkdown(markdown) }}
    />
  );
};

export default MarkdownRenderer; 